const referralCodesTypes = {
    GET_REFERRAL_CODES_PENDING: "GET_REFERRAL_CODES_PENDING",
    GET_REFERRAL_CODES_SUCCESS: "GET_REFERRAL_CODES_SUCCESS",
    GET_REFERRAL_CODES_ERROR: "GET_REFERRAL_CODES_ERROR",
    SET_REFERRAL_CODES_PARAMS: "SET_REFERRAL_CODES_PARAMS",
    RESET_REFERRAL_CODES: "RESET_REFERRAL_CODES",
}

export default referralCodesTypes;
